/**
 * Checks if window and storage APIs are available (e.g. not in SSR).
 * Similar to @atlassian/browser-storage-controls isSSR + isStorageAvailable logic.
 * Returns false when window/document are undefined or storage throws (SSR, private browsing).
 */
export const isStorageAPIAvailable = (): boolean => {
	try {
		const isMissingBrowserUtils =
			typeof globalThis.document === 'undefined' ||
			typeof globalThis.window === 'undefined' ||
			typeof document === 'undefined' ||
			typeof window === 'undefined' ||
			typeof globalThis.localStorage === 'undefined' ||
			typeof globalThis.sessionStorage === 'undefined' ||
			typeof localStorage === 'undefined' ||
			typeof sessionStorage === 'undefined' ||
			!Document ||
			!Document.prototype ||
			!Object ||
			!Object.defineProperty;
		if (isMissingBrowserUtils) {
			return false;
		}
		return true;
	} catch {
		return false;
	}
};
